const iCONSAPI = (fetch, baseUrl) => ({
  login: (username, password) => fetch(
    baseUrl + '/login', {
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json'
      },
      method: 'POST',
      body: JSON.stringify({
        username, password
      })
    }
  ),
  logout: () => fetch(
    baseUrl + '/logout', {
      credentials: 'include',
      method: 'POST'
    }
  ),
  getBeacons: () => fetch(
    baseUrl + '/beacons', {
      credentials: 'include',
      method: 'GET'
    }
  ),
  getGateways: () => fetch(
    baseUrl + '/gateways', {
      credentials: 'include',
      method: 'GET'
    }
  )
  /*
  getGameSpecs: () => fetch(
    baseUrl + "/game_specs", {
      headers: {
        'Accept': 'application/json',
      },
      method: "GET"
    }
  ),
  postNewGame: gameSpecID => fetch(
    baseUrl + "/games", {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      method: "POST",
      body: JSON.stringify({
        game_spec_id: gameSpecID
      })
    }
  ),
  getGameState: gameID => fetch(
    baseUrl + "/games/" + gameID, {
      headers: {
        'Accept': 'application/json',
      },
      method: "GET"
    }
  ),
  postNextTurn: (gameID, controlActions) => fetch(
    baseUrl + "/games/" + gameID + "/play_turn", {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      method: "POST",
      body: JSON.stringify(controlActions)
    }
  )
  */
})

// FIXME: Set URL
const api = iCONSAPI(fetch, "https://alpha.icons-case-studies.net/api/v1")
api.timeout_ms = 3000

export default api



// WEBPACK FOOTER //
// ./src/iCONSAPI.js